import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { gql, graphql } from 'react-apollo';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { StickyContainer } from 'react-sticky';
import siteComponentTypes from './siteComponentTypes';
import analytics from './site-render/src/lib/analytics';
import SiteThemeProvider from '../src/site-render/src/SiteThemeProvider';

class Site extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    eventId: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    siteLanguage: PropTypes.string,
  };

  static defaultProps = {
    siteLanguage: null,
  };

  recordPageView(props) {
    const {
      eventId,
      data: {
        publicEvent: { site },
      },
    } = props;

    analytics.record('pageView', {
      event: { id: eventId },
      site: { id: site.id },
    });
  }

  componentDidMount() {
    const jssStyles = document.getElementById('jss-server-side');
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }

    if (this.props.data.publicEvent) {
      this.recordPageView(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.data.publicEvent && nextProps.data.publicEvent) {
      this.recordPageView(nextProps);
    }
  }

  render() {
    const {
      classes,
      data: { publicEvent },
      language,
    } = this.props;

    if (!publicEvent) {
      return null;
    }

    const { site } = publicEvent;

    const siteComponents = [...site.sections, ...site.extensions];

    return (
      <SiteThemeProvider site={site}>
        <StickyContainer className={classes.root}>
          {siteComponents.map(section => {
            const Component = siteComponentTypes[section.type];
            return (
              Component && (
                <Component
                  key={section.id}
                  section={section}
                  site={site}
                  event={publicEvent}
                  language={language}
                />
              )
            );
          })}
        </StickyContainer>
      </SiteThemeProvider>
    );
  }
}

const styles = {
  '@global': {
    body: {
      margin: 0,
      padding: 0,
    },
  },
  root: {
    height: '100vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
  },
};

export default compose(
  graphql(
    gql`
      query publicEvent($eventId: String!, $language: Language!) {
        publicEvent(id: $eventId) {
          id
          name
          registrationLink
          mainLanguage
          languages
          registerEnabled
          registerHideBuyerFieldsOnFreeOrders
          registerForeignBuyerEnabled
          registerShowCouponField
          dateRange {
            start
            end
          }
          address {
            timezone
            fullAddress
            location {
              lat
              lng
            }
          }
          site {
            id
            eventId
            sectionIds
            extensionIds
            title
            description
            image {
              type
              url
            }
            favicon {
              type
              url
            }
            styles
            published
            sections(language: $language) {
              id
              type
              data
              styles
            }
            extensions(language: $language) {
              id
              type
              data
              styles
            }
          }
          registerFormFieldIds
          registerPaymentForms {
            bankSlip {
              hiddenNextEvent
            }
            creditCard {
              installmentEnabled
            }
          }
        }
      }
    `,
    {
      options: {
        fetchPolicy: 'cache-and-network',
      },
    },
  ),
  injectSheet(styles),
)(Site);



// WEBPACK FOOTER //
// ./src/Site.js